"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdultServiceComplianceControl = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.AdultServiceComplianceControl = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.adult_service_compliance_control.label',
    fallbackLabel: 'Do you have targeted compliance controls in place that include specific measures designed to address unique challenges, such as a higher risk of money laundering, in this particular segment, as well as child abuse, human trafficking, modern slavery or organized crime? For example, enhanced transaction monitoring and enhanced due diligence measures specific for this industry?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_adult_service_segment', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_adult_service_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
